export default "__VITE_ASSET__BfHP0b3f__"